import defaultAxios from './axiosInstances/identityAxiosInstance';
import { createAxiosInstance } from './axiosInstances/identityAxiosInstance';

// Use dedicated PEME API base URL if configured, otherwise fall back to default gateway
const pemeAxios = process.env.REACT_APP_PEME_API_URL
  ? createAxiosInstance(process.env.REACT_APP_PEME_API_URL)
  : defaultAxios;

const api = {
  async getPipelineOverview() {
    const res = await pemeAxios.get('peme/pipeline-overview');
    return res.data;
  },
  async getCrewStatuses(params) {
    const res = await pemeAxios.get('peme/crew-statuses', { params });
    return res.data;
  },
  async getStats() {
    const res = await pemeAxios.get('peme/stats');
    return res.data;
  },
  async updateCrewStatus(id, data) {
    const res = await pemeAxios.put(`peme/crew-statuses/${id}`, data);
    return res.data;
  },
  async createCrewStatus(data) {
    const res = await pemeAxios.post('peme/crew-statuses', data);
    return res.data;
  },
};

export default api;
